module.exports = __webpack_public_path__ + "img/mark-Folder2.e23af65.svg";